import * as Select from '@/components/ui/select'
import type { ListCollection, SelectValueChangeDetails } from '@ark-ui/solid'
import type { FieldElementProps, FieldStore } from '@modular-forms/solid'
import { ChevronDownIcon } from 'lucide-solid'
import { type Component, Index, type JSX, Show, createMemo } from 'solid-js'

type SelectFieldProps = {
  onChange: (values: SelectValueChangeDetails<any>) => void
  field: FieldStore<any, any>
  innerTemplate?: (value: any) => JSX.Element
  formFieldProps: FieldElementProps<any, any>
  collection: ListCollection<any>
}

export const SelectField: Component<SelectFieldProps> = (props) => {
  const renderItem = (item: any) => {
    const i = item?.replaceAll?.('-', ' ')
    return props.innerTemplate ? props.innerTemplate(i) : i
  }

  const value = createMemo(() =>
    props.field.value ? [props.field.value] : []
  )

  return (
    <Select.Root
      collection={props.collection}
      value={value()}
      invalid={!!props.field.error}
      name={props.field.name}
      positioning={{ fitViewport: true, sameWidth: true }}
      onValueChange={props.onChange}
    >
      <Select.Control>
        <Select.Trigger borderColor={props.field.error && 'fg.error'} textTransform='capitalize'>
          <Show when={value().length} fallback={<Select.ValueText placeholder="Select..." />}>
            {renderItem(value()[0])}
          </Show>
          <Select.Indicator>
            <ChevronDownIcon />
          </Select.Indicator>
        </Select.Trigger>
      </Select.Control>

      <Select.Positioner>
        <Select.Content>
          <Select.ItemGroup>
            <Index each={props.collection.items}>
              {(item) => (
                <Select.Item item={item()}>
                  <Select.ItemText w='full' textTransform='capitalize'>{renderItem(item())}</Select.ItemText>
                  <Select.ItemIndicator>✓</Select.ItemIndicator>
                </Select.Item>
              )}
            </Index>
          </Select.ItemGroup>
        </Select.Content>
      </Select.Positioner>

      <Select.HiddenSelect {...props.formFieldProps} />
    </Select.Root>
  )
}
